<template>
    <div>
        <div v-for="(lineContent, index) in subGroupContent" :key="index" :class="{ 'striped': striped }">
            <slot :lineContent="lineContent"></slot>
        </div>
    </div>
</template>

<script>
export default {
    /**
     * @param example
     * "itemMps": [
        {
            "manuals": [
            {
                "manualId": 0,
                "qualColText": "string",
                "qualColId": 0
            }
        ],
     */

    props: {
        subGroupContent: { type: Array | Object },
        striped: { type: Boolean }
    }
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

.striped:nth-child(odd) {
    background: $grey-light;
}
</style>
